function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.44449 14.1027L5.74642 16.705L3.195 16.7589C2.4325 15.3466 2 13.7308 2 12.0137C2 10.3533 2.40438 8.78752 3.12117 7.40881H3.12172L5.39319 7.82466L6.38824 10.0793C6.17998 10.6856 6.06647 11.3365 6.06647 12.0137C6.06655 12.7487 6.19988 13.453 6.44449 14.1027Z",
  fill: "#FBBB00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8257 10.1342C21.9404 10.7377 22.0002 11.3609 22.0002 11.9979C22.0002 12.7121 21.925 13.4088 21.7818 14.0809C21.2955 16.3677 20.0249 18.3646 18.2647 19.7778L18.2642 19.7772L15.414 19.632L15.0106 17.117C16.1786 16.433 17.0913 15.3624 17.5721 14.0809H12.2307V10.1342H17.6501H21.8257Z",
  fill: "#518EF8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2679 19.7948L18.2685 19.7953C16.5518 21.1747 14.3712 22 11.9973 22C8.18258 22 4.86593 19.8685 3.17402 16.7318L6.42023 14.0755C7.26617 16.3324 9.44407 17.939 11.9973 17.939C13.0948 17.939 14.123 17.6424 15.0052 17.1247L18.2679 19.7948Z",
  fill: "#28B446"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3943 4.2971L15.1553 6.94344C14.2439 6.37493 13.1666 6.04651 12.0124 6.04651C9.40627 6.04651 7.19181 7.72082 6.38976 10.0503L3.13263 7.38917H3.13208C4.79609 4.18746 8.14825 2 12.0124 2C14.4384 2 16.6627 2.86239 18.3943 4.2971Z",
  fill: "#F14336"
});

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.8cd6274f.svg";
export { ForwardRef as ReactComponent };